module.exports = __webpack_public_path__ + "img/family-history-m.9050ce6b.svg";